<template>
    <common-modal :showCloseIcon="false" :width="width" :height="height" @close="emitEvent({ name: 'close', payload: $event })">
        <common-content-wrapper width="small">
            <common-content-spacer height="medium">
                <div class="modal-header">
                    <common-icon v-if="showWarningIcon" name="white-warning" size="medium-large"></common-icon>
                    <span class="modal-header--text">{{ headingText }}</span>
                </div>
                <p>{{ contentText }}</p>
                <common-buttons>
                    <common-button
                        v-if="noButtonText"
                        :label="noButtonText"
                        :isSubmittable="false"
                        type="secondary"
                        @click="emitEvent({ name: 'close', payload: $event })"
                    ></common-button>
                    <common-button
                        v-if="yesButtonText"
                        :label="yesButtonText"
                        :isSubmittable="false"
                        type="primary"
                        @click="
                            emitEvent({
                                name: 'continue',
                                payload: {
                                    $event,
                                    ...payload,
                                },
                            })
                        "
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>
<script>
    export default {
        props: {
            headingText: { type: String, default: '' },
            contentText: { type: String, default: '' },
            noButtonText: { type: String, required: true },
            yesButtonText: { type: String, required: true },
            showWarningIcon: { type: Boolean, default: false },
            payload: { type: Object, default: undefined },
            height: { type: String, default: 'medium' },
            width: { type: String, default: 'large' },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .modal-header {
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
            margin-right: 10px;
        }
        &--text {
            line-height: $line-height--heading;
            font-size: 20px;
            font-weight: 700;
        }
    }
</style>
